import { render, staticRenderFns } from "./SlideoutContainer.vue?vue&type=template&id=2fc99318&scoped=true&"
import script from "./SlideoutContainer.vue?vue&type=script&lang=js&"
export * from "./SlideoutContainer.vue?vue&type=script&lang=js&"
import style0 from "./SlideoutContainer.vue?vue&type=style&index=0&id=2fc99318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc99318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc99318')) {
      api.createRecord('2fc99318', component.options)
    } else {
      api.reload('2fc99318', component.options)
    }
    module.hot.accept("./SlideoutContainer.vue?vue&type=template&id=2fc99318&scoped=true&", function () {
      api.rerender('2fc99318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/SlideoutContainer.vue"
export default component.exports